import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import './PurchaseListFilters.css';

function PurchaseListFilters({ handleFilters }) {
    const [applicantStatusFilter, setApplicantStatusFilter] = useState({
        New: false,
        Expired: false,
        OutOfStock: false
    });
    const { register, handleSubmit } = useForm();

    const applicantSTatusFilterChange = (e) => {
        setApplicantStatusFilter({ ...applicantStatusFilter, [e.target.name]: e.target.checked });
    }

    useEffect(() => {
        handleFilters(applicantStatusFilter);
    }, [applicantStatusFilter]);

    const handleChangedFilter = (data) => {
        console.log(data);
        handleFilters(data);
    }

    return (
        <>
            <div className="PurchaseListFilter">
                <FormGroup row>
                    <div className="PurchaseListFilter__filtersSelected allProducts__productStatusContent">
                        <FormControlLabel
                            control={<Checkbox checked={applicantStatusFilter.New} 
                            onChange={applicantSTatusFilterChange} name="New" className="allProducts__productStatusFilterCheckbox" />}
                            label="New"
                        />
                    </div>
                    <div className="PurchaseListFilter__filtersShortListed allProducts__productStatusContent">
                        <FormControlLabel
                            control={<Checkbox checked={applicantStatusFilter.Expired} onChange={applicantSTatusFilterChange} 
                            name="Expired" className="allProducts__productStatusFilterCheckbox" />}
                            label="Expired"
                        />
                    </div>
                    <div className="PurchaseListFilter__filtersRejected allProducts__productStatusContent">
                        <FormControlLabel
                            control={<Checkbox checked={applicantStatusFilter.OutOfStock} onChange={applicantSTatusFilterChange} 
                            name="OutOfStock" className="allProducts__productStatusFilterCheckbox" />}
                            label="OutOfStock"
                        />
                    </div>
                </FormGroup>
            </div>
        </>
    )
}

export default PurchaseListFilters
